import { render } from "./WeekSlider.vue?vue&type=template&id=231fe1af"
import script from "./WeekSlider.vue?vue&type=script&lang=js"
export * from "./WeekSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__